import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styles: [],
    standalone: true,
})
export class VideoComponent implements OnInit, OnDestroy {
  videoElement = document.querySelector('video') as HTMLVideoElement;
  showVideo: boolean;
  lang: string = 'es';
  step: number = 1;

  ngOnInit(): void {
    this.showHide('none');
  }

  ngOnDestroy(): void {
    this.hideVideoContainer();
  }

  btnCerrar() {
    this.hideVideoContainer();
  }

  hideVideoContainer() {
    this.showHide('none');
    if (this.videoElement) {
      this.videoElement.pause();
    }
  }

  video(lang: string, step: number) {
    this.showHide('block');
    this.lang = lang;
    this.step = step;
    if (this.videoElement) {
      this.videoElement.setAttribute(
        'src',
        `../../assets/videos/${lang}/step-${step}.mp4`
      );
      this.videoElement.autoplay = true;
    }
  }

  showHide(display: string) {
    const content = document.getElementById('show-video');
    if (content) {
      content.style.display = display;
    }
  }
}
